import { valid } from "@/common/libs/valid";
import { LANGUAGE } from "@/common/libs/Contains";
import { http } from "@/common/http";
import { aesEncrypt, MD5 } from "@/common/http/encrypt";
//import { formatSeconds } from "@/common/libs/utils";
const install = function(vue) {
  // vue.filter("formatSeconds", function(value) {
  //   if (!value) return "";
  //   return formatSeconds(value);
  // });

  vue.prototype._ = window.B.getFormatText.bind(window.B);
  vue.prototype.$valid = valid;
  vue.prototype.$LANGUAGE = LANGUAGE;
  vue.prototype.$getData = http.get;
  vue.prototype.$postModule = http.postModule;
  vue.prototype.$jsonp = http.jsonp;
  vue.prototype.$post = http.post;
  vue.prototype.$refresh = http.refresh;
  vue.prototype.$put = http.put;
  vue.prototype.$delete = http.delete;
  vue.prototype.$downFile = http.downFile;
  vue.prototype.$md5 = MD5;
  vue.prototype.$aesEncrypt = aesEncrypt;

  //表单title结束为冒号
  vue.prototype.$colonTips = ":";

  let hasCssList = (function() {
    return typeof document.body.cssList == "object";
  })();
  /**
   * dom元素添加类
   *
   * @returns
   */
  HTMLElement.prototype.addClass = function(...args) {
    if (hasCssList) {
      this.classList.add(args);
    } else {
      let classList = this.className.split(" ");
      for (let i = 0; i < args.length; i++) {
        if (classList.indexOf(args[i]) == -1) {
          classList.push(args[i]);
        }
      }
      this.className = classList.join(" ").trim();
    }
    return this;
  };

  /**
   * dom元素删除类
   *
   * @returns
   */
  HTMLElement.prototype.removeClass = function(...args) {
    if (hasCssList) {
      this.classList.remove(args);
    } else {
      let classList = this.className.split(" "),
        index;
      for (let i = 0; i < args.length; i++) {
        index = classList.indexOf(args[i]);
        if (index !== -1) {
          classList.splice(index, 1);
        }
      }
      this.className = classList.join(" ").trim();
    }
    return this;
  };
};

export default {
  install
};
